import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';
import { TOrderListItem } from 'redux/reducers/orderManagement/types';
import { DATE_FILTER } from '../../ui/EasTable/constants';
import { EIconButtons } from '../../ui/EasTable/EasTableRow/EasTableValue/constants';
import {
	EOrderSchemeCode,
	EOrderSchemeName,
	EOrderStatusCode,
	ORDER_STATUS_FILTER,
} from '../../redux/reducers/orderManagement/constants';

const ORDER_SCHEME_FILTER: [string, string][] = [
	[EOrderSchemeCode.B2B_INTRA_COMMUNAL, EOrderSchemeName['B2B-INTRA-COMMUNAL']],
	[EOrderSchemeCode.B2B_DOMESTIC, EOrderSchemeName['B2B-DOMESTIC']],
	[EOrderSchemeCode.B2C_DOMESTIC, EOrderSchemeName['B2C-DOMESTIC']],
	[EOrderSchemeCode.FC, EOrderSchemeName['FC-REP']],
	[EOrderSchemeCode.GIFTCARD_SCHEME, EOrderSchemeName.GIFTCARD_SCHEME],
	[EOrderSchemeCode.IOSS_IMPORT, EOrderSchemeName['IOSS-IMPORT']],
	[EOrderSchemeCode.EI_FACILITATION, EOrderSchemeName.EI_FACILITATION],
	[EOrderSchemeCode.IOSS_NON_UNION, EOrderSchemeName['IOSS-NON-UNION']],
	// [EOrderSchemeCode.FC_SIMPLE_REP, EOrderSchemeName['FC-SIMPLE-REP']],
	[EOrderSchemeCode.NON_EU_DOMESTIC, EOrderSchemeName.NON_EU_DOMESTIC],
	[EOrderSchemeCode.NON_EU_IMPORT, EOrderSchemeName.NON_EU_IMPORT],
	[EOrderSchemeCode.IOSS_UNION, EOrderSchemeName['IOSS-UNION']],
];

export const tableStructure: TTableStructure<keyof TOrderListItem>[] = [
	// {
	// 	selector: 'id',
	// 	name: 'Link',
	// 	show: false,
	// 	sortable: false,
	// 	filterable: false,
	// 	type: ETableStructureType.LINK,
	// 	align: ETableStructureAlign.LEFT,
	// 	colSpan: 1,
	// },
	{
		selector: 'has_returns',
		noName: true,
		name: 'Has Returns',
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.ICON,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
		icons: [
			{
				value: 'Returns',
				icon: EIconButtons.UNDO,
			},
		],
		value: (item: TOrderListItem) => {
			return item.has_returns ? 'Returns' : 'No';
		},
	},
	{
		selector: 'has_discount',
		noName: true,
		name: 'Has Discounts',
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.ICON,
		align: ETableStructureAlign.LEFT,
		filter: [
			['true', 'Yes'],
			['false', 'No'],
		],
		colSpan: 1,
		icons: [
			{
				value: 'Discounts',
				icon: EIconButtons.DISCOUNT,
			},
		],
		value: (item: TOrderListItem) => {
			return item.has_discount ? 'Discounts' : 'No';
		},
	},
	{
		selector: 'has_corrections',
		noName: true,
		name: 'Has VAT Corrections',
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.ICON,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
		icons: [
			{
				value: 'VAT Corrections',
				icon: EIconButtons.RULE,
			},
		],
		value: (item: TOrderListItem) => {
			return item.has_corrections ? 'VAT Corrections' : 'No';
		},
	},

	{
		selector: 'id',
		name: 'Id',
		show: true,
		sortable: true,
		filterable: false,
		separateFilter: true,
		type: ETableStructureType.LINK,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
		key: true,
	},
	{
		selector: 'external_order_id',
		name: 'External Order ID',
		show: true,
		sortable: true,
		filterable: false,
		separateFilter: true,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'em_full_name',
		name: 'EM Full Name',
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'em_id',
		name: 'EM',
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.EM,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
		value: (item: TOrderListItem) => {
			return { id: item.em_id, name: item.em_full_name };
		},
	},
	{
		selector: 'payment_currency_code',
		name: 'Payment Currency',
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'total_payable_by_fc',
		name: 'Order Total',
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
		currency: (item: TOrderListItem) => {
			return item.payment_currency_code ?? 'EUR';
		},
	},

	{
		selector: 'delivery_cost_inclusive_vat',
		name: 'Delivery Price Incl. VAT',
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
		currency: (item: TOrderListItem) => {
			return item.payment_currency_code ?? 'EUR';
		},
	},
	{
		selector: 'delivery_cost',
		name: 'Delivery Price',
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
		currency: (item: TOrderListItem) => {
			return item.payment_currency_code ?? 'EUR';
		},
	},
	{
		selector: 'total_merch_cost',
		name: 'Total Merch Amount',
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
		currency: (item: TOrderListItem) => {
			return item.payment_currency_code ?? 'EUR';
		},
	},
	{
		selector: 'total_vat',
		name: 'Total VAT',
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
		currency: (item: TOrderListItem) => {
			return item.payment_currency_code ?? 'EUR';
		},
	},
	{
		selector: 'total_custom_duties',
		name: 'Total Customs Duty',
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
		currency: (item: TOrderListItem) => {
			return item.payment_currency_code ?? 'EUR';
		},
	},
	{
		selector: 'delivery_cost_inclusive_vat',
		name: 'VAT incl.',
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.BOOLEAN,
		align: ETableStructureAlign.CENTER,
		colSpan: 1,
		value: (item: TOrderListItem) => {
			return item.delivery_cost_inclusive_vat > 0;
		},
	},

	{
		selector: 'eas_fees_due',
		name: 'Total EAS Fee',
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
		currency: (item: TOrderListItem) => {
			return item.payment_currency_code ?? 'EUR';
		},
	},
	{
		selector: 'is_delivery_to_person',
		name: 'Delivery to a Person',
		show: true,
		sortable: true,
		filterable: true,
		type: ETableStructureType.BOOLEAN,
		align: ETableStructureAlign.CENTER,
		colSpan: 1,
		filter: [
			['true', 'Yes'],
			['false', 'No'],
		],
	},
	{
		selector: 'delivery_country_code',
		name: 'Country',
		show: true,
		sortable: true,
		filterable: true,
		type: ETableStructureType.COUNTRY_CODE,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'recipient_title',
		name: 'Recipient Title',
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'recipient_first_name',
		name: 'Recipient First Name',
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'recipient_last_name',
		name: 'Recipient Last Name',
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},

	{
		selector: 'delivery_method',
		name: 'Method of Delivery',
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'recipient_company_name',
		name: 'Company Name',
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'recipient_company_vat',
		name: 'Company VAT Number',
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'delivery_address_line_1',
		name: 'Address Line 1',
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'delivery_address_line_2',
		name: 'Address Line 2',
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'delivery_city',
		name: 'City',
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'delivery_state_province',
		name: 'State/Province',
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'delivery_postal_code',
		name: 'Postal Code',
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'delivery_phone',
		name: 'Recipient Phone',
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'delivery_email',
		name: 'Recipient Email',
		show: false,
		sortable: true,
		filterable: true,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'fc_ip_address',
		name: 'FC IP',
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'daily_exchange_rate',
		name: 'Daily Exchange Rate',
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		selector: 'intrinsic_threshold_exchange_rate',
		name: 'Intrinsic Threshold Exchange Rate',
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		selector: 'calculated_threshod',
		name: 'Calculated Threshold',
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		currency: (item: TOrderListItem) => {
			return item.delivery_country === 234 || item.delivery_country === 250 ? 'GBP' : 'EUR';
		},
		colSpan: 1,
	},
	{
		selector: 'risk_flag_fc_nin',
		name: 'Risk Flag: FC ID',
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'risk_flag_fc_ip',
		name: 'Risk Flag: FC IP',
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'vat_duty_payment_mode',
		name: 'VAT/Duty Payment Mode',
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'customs_risk',
		name: 'Customs Risk Status',
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 's26_code',
		name: 'S26 Number',
		show: false,
		sortable: true,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'payment_verified_date',
		name: 'Payment Date',
		show: true,
		sortable: true,
		filterable: true,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.LEFT,
		filter: DATE_FILTER,
		colSpan: 1,
	},
	{
		selector: 'sale_date_provided_by_em',
		name: 'EM Sale Date',
		show: true,
		sortable: true,
		filterable: true,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.LEFT,
		filter: DATE_FILTER,
		colSpan: 1,
	},
	{
		selector: 'post_sale_payment_verified_date',
		name: 'Post Sale Payment Date',
		show: true,
		sortable: true,
		filterable: true,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.LEFT,
		filter: DATE_FILTER,
		colSpan: 1,
	},
	{
		selector: 'timestamp_utc',
		name: 'EAS Processed date',
		show: false,
		sortable: false,
		filterable: true,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.LEFT,
		filter: DATE_FILTER,
		colSpan: 1,
	},
	{
		selector: 'sale_type',
		name: 'Order Type',
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
		filter: [
			['REGULAR_SALE', 'Regular Sale'],
			['POST_SALE', 'Post Sale'],
			['POST_SALE_WITHOUT_LC', 'Post Sale Without LC'],
		],
	},
	{
		selector: 'schema_list',
		name: 'Schemes',
		show: true,
		sortable: true,
		filterable: true,
		type: ETableStructureType.STATUS_ARRAY,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
		filter: ORDER_SCHEME_FILTER,
		value: (item: TOrderListItem) => {
			return item?.schema_list
				?.replaceAll('{', '')
				?.replaceAll('}', '')
				?.split(',')
				?.map((schema) => EOrderSchemeName[schema as keyof typeof EOrderSchemeName]);
			// .join(', ');
		},
	},
	{
		selector: 'recipient_company_vat_validated',
		name: 'Company VAT Validated',
		show: false,
		sortable: true,
		filterable: true,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		selector: 'order_status',
		name: 'Order Status',
		show: true,
		sortable: true,
		filterable: true,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
		defaultFilterValue: EOrderStatusCode.PAYMENT_VERIFIED,
		filter: ORDER_STATUS_FILTER,
		colors: [
			[EOrderStatusCode.POST_SALE_CONFIRMED, 'success.light'],
			[EOrderStatusCode.POST_SALE_SHIPPED, 'success.light'],
			[EOrderStatusCode.ACCEPTED, 'success.light'],
			[EOrderStatusCode.VALIDATION_FAILED, 'error.light'],
			[EOrderStatusCode.FC_CONFIRMED, 'success.light'],
			[EOrderStatusCode.FC_REFUSED, 'error.light'],
			[EOrderStatusCode.PAYMENT_VERIFIED, 'success.light'],
			[EOrderStatusCode.PAYMENT_REJECTED, 'error.light'],
		],
	},
];
